<template>
  <div v-if="pageStep === 0" class="login-panel">
    <input type="text" v-model="passwd" />
    <button @click="login">PASS</button>
  </div>
  <div v-if="pageStep === 1">
    <ul class="play-list">
      <li v-for="item in list" @click="onItemClick(item)" :key="item">
        {{ item.name }}
      </li>
    </ul>
  </div>
  <div v-if="pageStep === 2">
    <button @click="pageStep = 1">goBack</button>
    <video-player
      class="video-player"
      :playsinline="playsinline"
      :options="playerOptions"
      :headers="headers"
      @click.stop
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)"
    />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PageIndex",
  data() {
    return {
      pageStep: 0,
      passwd: "",
      list: [],

      playsinline: true,
      //配置请求的headers
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=UTF-8",
        "Accept-Language": "zh-CN,zh;q=0.9,hy;q=0.8,mn;q=0.7",
        Authorization: "Bearer " + "token",
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "9:16", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            withCredentials: true,
            type: "application/x-mpegURL", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", // url地址
          },
        ],
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        hls: true,
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const movres = await axios.get("/assets/mov_list.json");
      const imgres = await axios.get("/assets/img_list.json");

      const movList = (movres.data || []).map((item) => ({
        type: "mov",
        name: (item || "").split("/").slice(-1)[0],
        url: item,
      }));
      const imgList = (imgres.data || []).map((item) => ({
        type: "image",
        name: (item || "").split("/").slice(-1)[0],
        url: item,
      }));
      this.list = [...movList, ...imgList];
    },
    login() {
      if (this.passwd === "keyvutet") {
        this.pageStep = 1;
      }
    },
    onItemClick(item) {
      if (item.type === "mov") {
        this.pageStep = 2;
        this.playerOptions.sources = [
          {
            withCredentials: true,
            type: "application/x-mpegURL",
            src: item.url,
          },
        ];
      } else {
        window.open(item.url);
      }
    },

    // 事件监听
    onPlayerPlay(player) {
      console.log("player play!", player);
    },
    onPlayerPause(player) {
      console.log("player pause!", player);
    },
    onPlayerEnded(player) {
      console.log("player ended!", player);
    },
    onPlayerLoadeddata(player) {
      console.log("player Loadeddata!", player);
    },
    onPlayerWaiting(player) {
      console.log("player Waiting!", player);
    },
    onPlayerPlaying(player) {
      console.log("player Playing!", player);
    },
    onPlayerTimeupdate(player) {
      console.log("player Timeupdate!", player.currentTime());
    },
    onPlayerCanplay(player) {
      console.log("player Canplay!", player);
    },
    onPlayerCanplaythrough(player) {
      console.log("player Canplaythrough!", player);
    },
    playerStateChanged(playerCurrentState) {
      console.log(playerCurrentState);
    },
    // 播放器准备好之后
    playerReadied(player) {
      console.log(player);
      // 这块没太看懂，可以去查一下文档，我反正照着写的
      var hls = player.tech({ IWillNotUseThisInPlugins: true }).hls;
      console.log(hls);
      player.tech_.hls.xhr.beforeRequest = function (options) {
        console.log(options);
        const token = "token";
        options.headers = {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json;charset=UTF-8",
          "Accept-Language": "zh-CN,zh;q=0.9,hy;q=0.8,mn;q=0.7",
          Authorization: "Bearer " + token,
        };
        return options;
      };
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.login-panel {
  padding: 50px 0;
  text-align: center;
}
.play-list li {
  padding: 10px;
  text-align: left;
  color: #0000ff;
}
</style>
